
var EventFilterApp = {};

(function($){
    const cookieLen =  0.01041667;
    EventFilterApp.debugging = false;
    EventFilterApp.message_log = [];
    EventFilterApp.logMessage = function(){
        let args = Array.from( arguments );
        args.forEach(function(element) {
            EventFilterApp.message_log.push( element );
        } );
        if ( EventFilterApp.debugging ) {
            console.log( args ); // eslint-disable-line no-console
        }
    };
    var Filter = Backbone.Model.extend({
        defaults: {
            cats: [],
            tags: [],
            date_start: '',
            date_end :'',
            total_pages: null,
            current_page: 1
        }
    });
    EventFilterApp.CookieService = {
        setCookie: function(name, value, days) {
			var expires = '';

			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = '; expires=' + date.toUTCString();
			}

			document.cookie = name + '=' + (value || '') + expires + ';';
		},
		getCookie: function(name) {
			var cookies = document.cookie.split(';');
			for (var i in cookies) {
				var cookie = cookies[i];
				if (cookie.indexOf(name + '=') > -1) {
					return cookie.split('=')[1];
				}
			}

			return null;
		}
    };
    var FilterBar = Backbone.View.extend({
        el: '.frauenthal-event-filter',
        needsFilter: false,
        events: {
            'change input.ft-datepicker' : 'updateDate',
            'change input.filter-check' : 'updateCheck',
            'click a.refresh-filter': 'refreshFilter'
        },
        initialize: function(){
            this.needsFilter = false;
            _.bindAll( this, 'render', 'updateCheck', 'updateDate', 'refreshFilter', 'handleRefresh', 'initialLoad', 'filterCheck', 'initalFilterCheck', 'dateCheck', 'setFilterAction' );
            
            // this.initialLoad();
        },
        render: function(){
            // nothing really happening here.
        },
        setFilterAction: function(){
            EventFilterApp.logMessage( 'We should filter' );
            this.needsFilter = true;
        },
        initialLoad: function(){
            // check and see if the model has a saved state (ex back button), maybe store this in a cookie?

            let state = EventFilterApp.CookieService.getCookie( 'eventFilterState' );

            
                EventFilterApp.logMessage( JSON.parse( state ) );
            

            if ( typeof state !== 'undefined' && ! _.isEmpty( state ) ) {
                let filterState = JSON.parse( state );
                delete filterState.total_pages;
                delete filterState.current_page;
                this.model.set( filterState );
                let filters = ['cats', 'tags'];
                filters.forEach( this.initalFilterCheck );
                $( 'input.ft-datepicker', this.el ).each( this.dateCheck );
                if ( this.needsFilter ) {
                    this.refreshFilter();
                    EventFilterApp.logMessage( 'We are filtering' );
                    this.needsFilter = false;
                } else {
                    EventFilterApp.logMessage( 'We are not filtering', this.needsFilter );
                }
            }
        },
        initalFilterCheck: function( key ){
            var self = this;
            let setting = this.model.get( key );
            if ( !_.isEmpty( setting ) ) {
                // check those boxes
                $( 'input[data-filter="'+key+'"]', this.el).each(function( i, item ){
                    if ( setting.includes( item.value ) ) {
                        item.checked = true;
                        self.setFilterAction();
                    }
                });
            }
        },
        filterCheck: function( key ){
            
            var vals = [];
            $( 'input[data-filter="'+key+'"]', this.el).each(function( i, item ){
                if ( item.checked ) {
                    vals.push( item.value );
                }
                
                    EventFilterApp.logMessage( item.value, item.checked );
                
            });
            
                EventFilterApp.logMessage( key, vals );
            
            this.model.set( key, vals );
        },
        dateCheck: function( index, input ){
            
                EventFilterApp.logMessage( index, input );
            
            var key = input.dataset.filter;
            var val = this.model.get( key );

            if ( val.length ) {
                input.value = val;
                this.setFilterAction();
            }
        },
        updateCheck: function(e){
           // this.model
            var key = e.currentTarget.dataset.filter;
            
                EventFilterApp.logMessage( key, 'updateCheck' );
            
            this.filterCheck( key );
            $( '.event-refresh', this.el ).removeClass( 'disabled' );

        },
        updateDate: function(e){
            var key = e.currentTarget.dataset.filter;
            var val = e.currentTarget.value;

            this.model.set( key, val );
            // EventFilterApp.logMessage( 'date update' );
            $( '.event-refresh', this.el ).removeClass( 'disabled' );
        },
        
        refreshFilter: function( e ){
            if ( typeof e !== 'undefined' ) {
                e.preventDefault();
            }

            $( '.event-refresh', this.el ).addClass( 'disabled' );
            var params = this.model.toJSON();
            params.current_page = 1;
            $( '.tribe-events-calendar-list' ).html('');
            $( '.tribe-events-view-loader').removeClass( 'tribe-common-a11y-hidden' );
            $.ajax({
                url : site_data.api_url_base + 'frauenthal/v1/events',
                data: params
            }).done(this.handleRefresh);
            // send this to the API
        },
        handleRefresh: function( response ){
            // replace the events with results from the api
            
                EventFilterApp.logMessage( response );
            
            let state = this.model.toJSON();

            let stateObj = {
                cats: state.cats,
                tags: state.tags,
                date_start: state.date_start,
                date_end :state.date_end
            };
            
            EventFilterApp.logMessage( 'setting state cookie', stateObj );
            
            // store it as a cookie
            EventFilterApp.CookieService.setCookie( 'eventFilterState', JSON.stringify( stateObj ), cookieLen );
            EventFilterApp.CookieService.setCookie( 'eventsLoadedPage', 1, cookieLen );
            // history.pushState( state, '' );
            $( '.tribe-events-calendar-list' ).html( response.events );
            $( '.tribe-events-view-loader').addClass( 'tribe-common-a11y-hidden' );
            this.model.set( { total_pages : response.query.max_num_pages, current_page: 1 } );
        }
    });

    var LoadMoreEvents = Backbone.View.extend({
        el: '.tribe-load-more-nav',
        pageNum: false,
        events: {
            'click a.load-more': 'loadMore'
        },
        initialize: function(){
            _.bindAll( this, 'render', 'loadMore', 'handleResponse', 'initialLoad', 'handlePreload' );
            this.model.on('change', this.render, this);
            this.render();
        },
        initialLoad: function(){
            let pageNum = EventFilterApp.CookieService.getCookie( 'eventsLoadedPage' );

            
                EventFilterApp.logMessage( pageNum );
            

            if ( typeof pageNum !== 'undefined' && ! _.isEmpty( pageNum ) ) {
                this.pageNum = parseInt( pageNum );
                $( this.el ).on( 'eventPageLoaded', this.handlePreload );
                this.handlePreload();
            }
        },
        handlePreload: function(){
            
                EventFilterApp.logMessage( 'called handlePreload', this.pageNum );
            
            if ( this.pageNum > 1 ) {

                EventFilterApp.logMessage( 'yes' );
                // this.loadMore();
                $( 'a.load-more', this.el ).trigger( 'click' );
                this.pageNum--;
            } else {
                EventFilterApp.logMessage( 'no' );
                $( this.el ).off( 'eventPageLoaded', this.handlePreload );
            }
        },
        render: function(){
            var total = parseInt( this.model.get( 'total_pages' ) );
            
                EventFilterApp.logMessage( 'total',  total );
            
            if ( !isNaN( total ) ) {
                // lets see if load more should be active.

                var current = parseInt( this.model.get( 'current_page' ) );

                
                    EventFilterApp.logMessage( 'current', current );
                
                if (current >= total ) {

                    
                        EventFilterApp.logMessage( 'Hiding load more' );
                    
                    $( this.el ).addClass( 'd-none' );
                } else {
                    // EventFilterApp.logMessage( 'Showing load more' );
                    $( this.el ).removeClass( 'd-none' );
                }
            }
        },
        loadMore: function( e ){
            if ( typeof e !== 'undefined' ) {
                e.preventDefault();
            }

            var params = this.model.toJSON();
            params.current_page++; // get the next page
            $( '.tribe-events-view-loader').removeClass( 'tribe-common-a11y-hidden' );
            $.ajax({
                url : site_data.api_url_base + 'frauenthal/v1/events',
                data: params
            }).done(this.handleResponse);
            // call for more.
        },
        handleResponse: function( response ){
            // replace the events with results from the api
            
            
                EventFilterApp.logMessage( response );
            
            if ( 'No Events Found' === response.message ) {
                // skip appending it on load more
            } else {
                $( '.tribe-events-calendar-list' ).append( response.events );
            }
            // update the filter page variable
            EventFilterApp.CookieService.setCookie( 'eventsLoadedPage', response.query.query_vars.paged, cookieLen );
            
            
                EventFilterApp.logMessage( { total_pages : response.query.max_num_pages, current_page: response.query.query_vars.paged });
            
            this.model.set( { total_pages : response.query.max_num_pages, current_page: response.query.query_vars.paged }  );
            this.el.dataset.total_pages = response.query.max_num_pages;
            $( '.tribe-events-view-loader').addClass( 'tribe-common-a11y-hidden' );
            $( this.el ).trigger( 'eventPageLoaded' );
        }
    });

    $( document ).ready( function(){
       var pageCount = $( '.tribe-load-more-nav' ).data( 'total_pages' );
        
        EventFilterApp.filter_model = new Filter({'total_pages': pageCount});
        // EventFilterApp.filter_model.set( 'total_pages', pageCount );
        EventFilterApp.filter_bar = new FilterBar({model: EventFilterApp.filter_model});
        EventFilterApp.load_more = new LoadMoreEvents({model: EventFilterApp.filter_model});

        $( '.ft-datepicker' ).datepicker();
        EventFilterApp.filter_bar.initialLoad();
        EventFilterApp.load_more.initialLoad();
    } );
})(jQuery);